<template>
    <el-table
        :data="tableData"
        style="width: 100%; margin-top: 3px"
        :cell-style="{
            'font-size': '20px',
            'font-weight': '700',
            color: '#000',
        }"
        :header-cell-style="{
            'background-color': '#409eff',
            color: '#fff',
            'font-size': '22px',
        }"
    >
        <el-table-column
            label="课程类型"
            prop="courseType"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            prop="totalCount"
            label="总数"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div
                    style="color: red; cursor: pointer"
                    @click="linkTo(scope.$index, scope.row)"
                >
                    {{ scope.row.totalCount }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            prop="signCount"
            label="报名中"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div style="color: #409eff">
                    {{ scope.row.signCount }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            prop="learningCount"
            label="学习中"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div style="color: #4b794f">
                    {{ scope.row.learningCount }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            prop="noLearnCount"
            label="未开始学习"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            prop="closeCount"
            label="已结束学习"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            prop="stuLearnNum"
            label="在学人数"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            prop="stuTotalNum"
            label="学习总人数"
            align="center"
            header-align="center"
        ></el-table-column>
    </el-table>
</template>

<script>
export default {
    props: ["tableData"],
    methods: {
        linkTo(i, item) {
            if (i === 0) {
                this.$emit("linkTo", "class");
            }
            if (i === 1) {
                this.$emit("linkTo", "dibble");
            }
            if (i === 2) {
                this.$emit("linkTo", "live");
            }
            if (i === 3) {
                this.$emit("linkTo", "face");
            }
        },
    },
};
</script>

